<template>
  <List class="px-3" finished-text="没有更多了">
    <div
      v-for="(item, index) in filtedList"
      :key="index"
      class="flex flex-col mb-3 lightshadow rounded-xl overflow-hidden"
    >
      <div
        v-show="status !== '2'"
        class="flex flex-row flex-no-wrap overflow-x-auto"
        @click="
          $router.push({ name: 'ActivityPlace', params: { aid: item.actId } })
        "
      >
        <div class="w-full flex-shrink-0 mr-3">
          <img :src="item.banner" class="w-full" style="height: 112px" alt="" />
        </div>
        <div
          v-for="good in item.brandGoodsList"
          :key="good.partGoodsId"
          class="flex flex-col mr-3"
        >
          <div
            style="height: 90px; width: 90px"
            class="rounded-md overflow-hidden"
          >
            <img :src="good.goodsImage" class="h-full w-full" alt="" />
          </div>
          <div class="flex flex-row justify-between items-center">
            <div>
              <span class="text-xs">¥</span
              ><span class="text-base font-semibold">{{ good.actPrice }}</span>
            </div>
            <span
              v-distributor="true"
              class="text-red"
              style="white-space: nowrap"
              ><span class="text-xxs">省赚¥</span
              ><span class="text-xs">{{ good.saveProfit }}</span></span
            ><span
              v-distributor="false"
              class="text-gray line-through text-xs"
              style="white-space: nowrap"
              >{{ good.linePrice }}</span
            >
          </div>
        </div>
        <div
          class="
            flex-shrink-0
            mr-3
            rounded-md
            flex flex-col
            items-center
            justify-center
          "
          style="background-color: #d8d8d8; height: 90px; width: 90px"
        >
          <div class="-mb-1">查看</div>
          <div class="-mt-1">更多</div>
        </div>
      </div>
      <div
        v-show="status !== '2'"
        class="flex flex-row justify-between mr-2 text-xs px-2 pt-2"
      >
        <span
          @click="
            $router.push({ name: 'ActivityPlace', params: { aid: item.actId } })
          "
          ><div
            v-show="item.state === 'IN_PROGRESS'"
            style="
              width: 36px;
              height: 20px;
              line-height: 20px;
              background: linear-gradient(135deg, #acf700 0%, #6edf0f 100%);
              border-radius: 5px;
            "
            class="text-xs inline-block text-center mr-1"
          >
            上新
          </div>
          <div
            v-show="item.state === 'WARMING_UP'"
            style="
              width: 36px;
              height: 20px;
              line-height: 20px;
              background: linear-gradient(315deg, #ffb1b1 0%, #f70000 100%);
              border-radius: 5px;
            "
            class="text-xs inline-block text-center mr-1 text-white"
          >
            预告
          </div>
          <span class="font-semibold">{{ item.actName }}</span></span
        >
        <Button
          v-distributor="false"
          style="padding-left: 8px; padding-right: 8px"
          round
          color="#E82035"
          size="mini"
          @click="
            $router.push({ name: 'ActivityPlace', params: { aid: item.actId } })
          "
          >进入会场 >
        </Button>
        <Button
          v-distributor="true"
          style="padding-left: 8px; padding-right: 8px"
          round
          color="#E82035"
          size="mini"
          @click="showDiag(item)"
          >分享赚钱
          <img
            class="inline-block h-3"
            src="@/assets/brandplace/forward.svg"
            alt=""
        /></Button>
      </div>
      <div v-show="status === '2'" class="flex justify-between py-2 px-3">
        <div class="font-semibold text-sm">{{ item.actName }}</div>
        <div class="text-red text-xs">活动已结束</div>
      </div>
      <div
        v-show="status !== '2'"
        class="flex flex-row justify-between flex-no-wrap items-center mr-2 p-2"
        @click="
          $router.push({ name: 'ActivityPlace', params: { aid: item.actId } })
        "
      >
        <div class="flex flex-row flex-no-wrap overflow-x-scroll h-5">
          <span
            v-for="services in item.actServiceList"
            :key="services.id"
            class="text-xxs text-red border-red1px rounded px-1 mr-1"
            style="white-space: nowrap; line-height: 1.125rem"
            >{{ services.name }}</span
          >
        </div>
        <div class="text-left flex-shrink-0 flex items-end">
          <Countdown :startTime="item.start" :endTime="item.end" :padding="0" />
        </div>
      </div>
    </div>
    <Overlay
      :show="diagVisible"
      @click="
        () => {
          diagVisible = false;
          showShare = false;
        }
      "
    >
      <div
        v-show="!showShare"
        class="wrapper mx-12"
        :class="showInput ? '-my-2' : 'my-12'"
        @click.stop
      >
        <div class="bg-white rounded-lg mb-6 overflow-auto p-3 text-left">
          <div class="flex items-center mb-2">
            <div style="height: 46px; width: 46px" class="flex-shrink-0 mr-3">
              <img
                :src="forwardDetail.logoUrl"
                class="h-full w-full rounded"
                alt=""
              />
            </div>
            <div class="flex flex-col">
              <div class="text-xs font-semibold">
                {{ forwardDetail.activityName }}
              </div>
              <div class="text-xs">{{ forwardDetail.brandName }}</div>
            </div>
          </div>
          <div class="flex justify-center">
            <div style="height: 182px; width: 182px" class="mr-1">
              <img
                :src="forwardDetail.posterImg"
                class="h-full w-full rounded"
                alt=""
              />
            </div>
            <div class="flex flex-col justify-between">
              <img
                style="height: 89px; width: 89px"
                :src="forwardDetail.rightImgOne"
                alt=""
                class="rounded"
              />
              <img
                style="height: 89px; width: 89px"
                :src="forwardDetail.rightImgTwo"
                alt=""
                class="rounded"
              />
            </div>
          </div>
          <div class="text-xs py-1">
            {{ forwardDetail.goodsName }}
          </div>
          <div class="text-xs"></div>
          <div class="flex justify-between mb-3">
            <div class="text-red">
              <span class="text-xs">¥</span
              ><span class="font-semibold mr-2">{{ forwardDetail.price }}</span
              ><span class="text-xxs font-semibold"
                >赚：{{ forwardDetail.saveProfit }}元</span
              >
            </div>
            <div class="text-xs">
              {{
                dayjs(forwardDetail.activityTime).format("MM[月]DD[日] HH:mm")
              }}结束
            </div>
          </div>
          <!-- <div>
            <div class="text-xs">加价：</div>
            <div class="flex justify-between text-xs -mx-1 mb-2">
              <div
                style="background-color: #f1f1f1"
                class="h-8 leading-8 mx-1 flex-grow text-center rounded"
                :class="{ activejiajia: jiajiaway === 1 }"
                @click="() => (jiajiaway = 1)"
              >
                不加价
              </div>
              <div
                style="background-color: #f1f1f1"
                class="h-8 leading-8 mx-1 flex-grow text-center rounded"
                :class="{ activejiajia: jiajiaway === 2 }"
                @click="() => (jiajiaway = 2)"
              >
                加价10元
              </div>
              <div
                style="background-color: #f1f1f1"
                class="h-8 leading-8 mx-1 flex-grow text-center rounded"
                :class="{ activejiajia: jiajiaway === 3 }"
                @click="() => (jiajiaway = 3)"
              >
                加价20%
              </div>
            </div>
            <div>
              <Field
                class="rounded h-8 pt-1"
                style="background-color: #f1f1f1"
                placeholder="自定义金额"
                input-align="center"
                readonly
                clickable
                :value="customjiajia"
                @touchstart.native.stop="
                  () => {
                    jiajiaway = 4;
                    showInput = true;
                  }
                "
              />
            </div>
          </div> -->

          <NumberKeyboard
            v-model="customjiajia"
            :show="showInput"
            theme="custom"
            extra-key="."
            close-button-text="完成"
            @blur="showInput = false"
          />
        </div>
        <Button
          style="height: 2rem"
          round
          color="linear-gradient(135deg, #E82237 0%, #FF9D9D 100%)"
          size="large"
          v-gapclick="generatePost"
          >生成海报</Button
        >
      </div>
    </Overlay>
  </List>
</template>

<script>
import {
  Button,
  List,
  Overlay,
  NumberKeyboard,
  Field,
  Image as VImage,
} from "vant";
import Countdown from "@/components/activity/Countdown";
import { getFollowingActs } from "../webApi";
import { priceMarkup, forwardDetail } from "@/api/forward.js";
export default {
  components: {
    Button,
    Countdown,
    List,
    Overlay,
    NumberKeyboard,
    // Field,
  },
  props: ["status"],
  created() {
    getFollowingActs(this.$route.query.partId).then(({ data }) => {
      this.activityList = data;
    });
  },
  data() {
    return {
      loading: false,
      finished: false,
      activityList: [],
      forwarding: null,
      forwardDetail: {},
      diagVisible: false,
      showInput: false,
      customjiajia: "",
      jiajiaway: 1,
      urlAddress: null,
      showShare: false,

      browserType: localStorage.getItem("browserType"),
    };
  },
  methods: {
    showDiag(item) {
      this.forwarding = item;
      forwardDetail({
        actId: this.forwarding.actId,

        suitId: null,
        customerId: null,
        retailId: null,
        forwardType: "ACTIVITY",
      }).then(({ data }) => {
        this.forwardDetail = data;
        // this.diagVisible = true;
        this.generatePost();
      });
    },

    generatePost() {
      let urlAddress;
      if (location.hostname === "localhost") {
        urlAddress =
          window.location.origin +
          location.pathname +
          "?customerId=" +
          this.$store.state.user.forwardId;
      } else {
        urlAddress =
          location.href + "?customerId=" + this.$store.state.user.forwardId;
      }
      this.urlAddress = urlAddress;
      let params = {
        actId: this.forwarding.actId,

        retailId: null,
        markupType: "NONE",
        markupAmount: 0,
        markupRatio: 0,
        forwardType: "ACTIVITY",
        price: 0,
        urlAddress,
      };
      switch (this.jiajiaway) {
        case 1:
          params.markupType = "NONE";
          params.price = this.forwardDetail.price;
          break;
        case 2:
          params.markupType = "AMOUNT";
          params.markupAmount = 10;
          params.price = this.forwardDetail.price + 10;
          break;
        case 3:
          params.markupType = "RATIO";
          params.markupRatio = 0.2;
          params.price = this.forwardDetail.price * 1.2;
          break;
        case 4:
          if (!this.customjiajia) {
            return;
          }
          params.markupType = "AMOUNT";
          params.markupAmount = Number(this.customjiajia);
          params.price = this.forwardDetail.price + Number(this.customjiajia);

          break;
        default:
          break;
      }
      console.log(params);
      console.log(this);
      priceMarkup(params).then(({ data }) => {
        // this.showShare = true;
        this.diagVisible = false;
        this.$store.dispatch("sharePoster/show", {
          url: data.url,
          title: this.forwarding.actName,
          desc: "",
          link: urlAddress,
          imgUrl: this.forwarding.brandLogo,
        });
      });
    },
  },
  computed: {
    filtedList() {
      switch (this.status) {
        case "0":
          return this.activityList.filter(
            (item) => item.state === "IN_PROGRESS"
          );
        case "1":
          return this.activityList.filter(
            (item) => item.state === "WARMING_UP"
          );
        case "2":
          return this.activityList.filter((item) => item.state === "FINISHED");

        default:
          return this.activityList;
      }
    },
  },
};
</script>

<style>
</style>